import { ComponentProps } from 'react';

import Form from '../../../components/Form/Form';
import HiddenField from '../../../components/HiddenField/HiddenField';
import SubmitButton from '../../../components/SubmitButton/SubmitButton';

type LogOutButtonProps = {
    actionUrl: string;
    bookingReference?: string;
} & ComponentProps<typeof SubmitButton>;

const LogOutButton = ({
    actionUrl,
    bookingReference,
    children,
    ...buttonProps
}: LogOutButtonProps) => {
    return (
        <Form method="post" action={actionUrl}>
            {bookingReference && (
                <HiddenField name="bookingReference" value={bookingReference} />
            )}

            <SubmitButton {...buttonProps}>{children}</SubmitButton>
        </Form>
    );
};

export default LogOutButton;
